import store from '@/store'

function checkPermission(el, binding) {
  const { value } = binding;
  const hasMenuBtnAuth = store.getters['user/hasMenuBtnAuth']

  if (value) {
    const hasPermission = hasMenuBtnAuth(value);
    if (!hasPermission && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  } else {
    throw new Error(`请填入权限标识! Like v-permission="USER_XXXX"`);
  }
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding);
  },
  updated(el, binding) {
    checkPermission(el, binding);
  }
}